export default {
  discount_badge: '{{value}} rabat',
  high_caffeine_warning_required: 'Højt koffeinindhold',
  pfand: 'Inkl. {{value}} pant',
  alcohol_by_volume_percent: '{{value}} % vol. alkohol',
};
